/* istanbul ignore file */
import React, { useRef } from 'react';
import compose from 'lodash/fp/compose';
import withFeedback from '@catalogo/template-americanas-desktop-question/src/components/hoc/feedback';
import withValidate from '@catalogo/template-americanas-desktop-question/src/components/hoc/validate';
import QuestionTips from '@catalogo/ui-americanas-mobile-qna/src/components/atoms/QuestionTips';
import { Text as InputQuestion } from '../../atoms/InputText';
import { Feedback, Button, SuccessFeedback, ModalSheetError } from '../../atoms';
import { FormTitle, Wrapper, Text } from './Styled';
import { IProps, IErrorStatusStr, IErrorStatusBool } from './types';

export const Form: React.FC<IProps> = ({
  text,
  setText,
  onSubmit,
  isSuccess,
  error,
  loading,
  timerFinished,
  backToForm,
}) => {
  const onClick = () => {
    onSubmit(text);
  };

  const ref = useRef(null);

  if (isSuccess) {
    return <SuccessFeedback />;
  }

  if (error.statusCode == 500) {
    return <ModalSheetError backToForm={backToForm} />;
  }

  return (
    <Wrapper>
      <FormTitle className="formTitle">Tá com dúvida sobre o produto?</FormTitle>
      <Text>Pergunta que a gente responde :)</Text>
      <InputQuestion
        error={error as IErrorStatusBool}
        key="Qna Form"
        onChange={event => setText(event.target.value)}
        feedback="máximo de 150 caracteres"
        label="Digite sua pergunta"
        value={text}
        validate="reviewText"
        maxLength={150}
      />
      <Feedback error={error as IErrorStatusStr} timerFinished={timerFinished} />
      <QuestionTips title="" id="" ref={ref}>
        <></>
      </QuestionTips>
      <Button fullWidth={true} loading={loading} disabled={!text} onClick={onClick} variant="primary">
        Enviar pergunta
      </Button>
    </Wrapper>
  );
};

export default compose(withValidate, withFeedback)(Form);
